// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader-module-pageHeader-v-F5d"};